<template>
  <div id="opea">
  </div>
</template>
<script >

import { ShowSuccessMessage } from '@/components/modal/tips/message-tips.js';

export default {
  name: 'CustomMessage',
  props: {
    /**
     * 右边button文字
     */
    confirmButtonText: {
      type: String,
      default: 'message.common.confirm',
    },
    /**
     * 左边button文字
     */
    cancelButtonText: {
      type: String,
      default: 'message.tableCommon.cancel',
    },
    /**
     * 点击透明部分是否关闭弹框(false为点击外部不关闭)
     */
    closeOnClickModal: {
      type: Boolean,
      default: true,
    },
    /**
     * 按下ESC键是否关闭弹框(false为点击不关闭)
     */
    closeOnPressEscape: {
      type: Boolean,
      default: true,
    },
    /**
     * 是否显示关闭按钮
     */
    showClose: {
      type: Boolean,
      default: true,
    },
    /**
     * 是否区分取消和关闭
     */
    distinguishCancelAndClose: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  methods: {
    openDefaultModal(messageBox, type = 'info') {
      this.$alert(messageBox.contentHtml, messageBox.titleHtml, {
        customClass: `rhcn-messsage rhcn-messsage-${type} ${this.customClass}`,
        dangerouslyUseHTMLString: true,
        cancelButtonClass: this.getCancelButtonClass(type),
        confirmButtonClass: this.getConfirmButtonClass(type),
        confirmButtonText: this.$t(this.confirmButtonText),
        cancelButtonText: this.$t(this.cancelButtonText),
        showCancelButton: !!this.cancelButtonText,
        closeOnClickModal: this.closeOnClickModal,
        closeOnPressEscape: this.closeOnPressEscape,
        distinguishCancelAndClose: this.distinguishCancelAndClose,
        showClose: this.showClose,
        beforeClose: (action, instance, done) => {
          if (messageBox.onOkClick && action === 'confirm') {
            messageBox.onOkClick(action, instance, done);
          } else {
            done();
          }
        },
        callback: (action) => {
          if (messageBox.onCallback) {
            messageBox.onCallback(action);
          }
        },
      });
    },
    openHttpModal(messageBox, type = 'info') {
      this.$alert(messageBox.contentHtml, messageBox.titleHtml, {
        customClass: `rhcn-messsage rhcn-messsage-${type} ${this.customClass}`,
        dangerouslyUseHTMLString: true,
        cancelButtonClass: this.getCancelButtonClass(type),
        confirmButtonClass: this.getConfirmButtonClass(type),
        confirmButtonText: this.$t(this.confirmButtonText),
        cancelButtonText: this.$t(this.cancelButtonText),
        showCancelButton: !!this.cancelButtonText,
        closeOnClickModal: this.closeOnClickModal,
        closeOnPressEscape: this.closeOnPressEscape,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm' && messageBox.httpFunction) {
            instance.confirmButtonLoading = true;
            messageBox.httpFunction(messageBox.params).then((data) => {
              done();
              instance.confirmButtonLoading = false;
              if (messageBox.successFunction) {
                messageBox.successFunction(data);
              }
              ShowSuccessMessage(messageBox.successTips ? this.$t(messageBox.successTips) : this.$t('message.operateSuccessfulTip'));
            }).catch(() => {
              // ShowErrorMessage(messageBox.errorTips ? proxy.$t(messageBox.errorTips) : '操作失败');
              instance.confirmButtonLoading = false;
              done();
            });
          } else if (action === 'confirm' && messageBox.confirmFuntion) {
            messageBox.confirmFuntion();
            done();
          } else {
            done();
          }
        },
      }).then(() => {
        if (messageBox.onCallback) {
          messageBox.onCallback();
        }
      }).catch((err) => {
        console.log(err);
        if (err === 'cancel' && messageBox.cancelFunction) {
          messageBox.cancelFunction();
        }
      });
    },
    getCancelButtonClass(type) {
      let className = 'el-button--medium';
      if (type === 'warn') {
        className = `${className} el-button--danger is-plain`;
      } else if (type === 'error') {
        className = `${className} el-button--danger is-plain`;
      }
      if (type === 'color-new') { // 新版ui配色
        className = `${className} el-button-color-new is-plain`;
      }
      return className;
    },
    getConfirmButtonClass(type) {
      let className = 'el-button--medium';
      if (type === 'error') {
        className = `${className} el-button-danger`;
      } else if (type === 'color-new') { // 新版ui配色
        className = `${className} el-button-color-new--primary`;
      } else {
        className = `${className}  el-button--primary`;
      }

      return className;
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
.el-message-box__wrapper{
  .el-message-box{
    width: 688px;
    max-width: 100%;
    padding-bottom: 30px;
    .el-message-box__header {
      border-bottom: 1px solid rgba(0,32,63,0.08);
      padding-top: 20px;
      padding-bottom: 11px;
      padding-left: 30px;
      .el-message-box__title {
        font-size: 20px;
        font-weight: 800;
        line-height: 36px;
      }
      .el-message-box__headerbtn {
        font-size: 23px;
        top: 20px;
        width: 27px;
        height: 27px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $color-white;
        &:hover {
          background-color: $color-default;
        }
        &:active {
          background-color: $color-default-active;
        }
        .el-message-box__close {
          font-weight: bold;
          color: $color-primary;
          font-size: 20px;
        }
      }
    }
    .el-message-box__content {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: $color-text-primary;
      padding: 19px 65px 39px 30px;
    }
    &.rhcn-messsage {
      border: 0;
      box-shadow: 0px 0px 20px 10px rgba(0,0,0,0.05);
      .el-button {
        &.el-button--medium {
          font-size: 16px;
          padding: 13px 12px;
          min-width: 100px;
        }
        &.el-button-color-new {
          border-color: $color-primary-purple;
          color: $color-primary-purple;
          background-color: $color-white;
        }
        &.el-button-color-new--primary {
          border-color: $color-primary-purple !important;
          color: $color-white !important;
          background-color: $color-primary-purple !important;
        }
        &.el-button--primary {
          background-color: $color-text-default-button;
          border-color: $color-text-default-button;
          color: $color-white;
          &:hover， &:focus {
            background-color: $color-hover;
            border-color: $color-hover;
          }
          &:active, &.is-loading {
            background-color: $color-active;
            border-color: $color-active;
          }
        }
        &.el-button-danger {
          background: $color-error;
          border-color: $color-error;
          color: $color-white;
          &:hover, &:focus {
            background: $color-error;
            border-color: $color-error;
          }
          &:active, &.is-loading {
            background: $color-error;
            border-color: $color-error;
          }
        }
        &.el-button--danger {
          border-color: $color-danger-1;
          background-color: $color-white;
          color: $color-error;
          &:hover, &:focus {
            border-color: $color-error;
            background-color: $color-error;
            color: $color-white;
          }
          &:active, &.is-loading {
            border-color: $color-danger-2;
            background-color: $color-danger-2;
            color: $color-white;
          }
        }
      }
      &.rhcn-messsage-info, &.rhcn-messsage-warn {
        .el-message-box__btns {
          padding-left: 30px;
          display: flex;
          flex-direction: row-reverse;
          align-items: flex-start;
          justify-content: flex-end;
          .el-button {
            &:nth-child(n+2) {
              margin-left: 0;
              margin-right: 25px;
            }
          }
        }
      }
      &.rhcn-messsage-error {
        background-color: $color-error;
        .el-message-box__header {
          .el-message-box__title {
            color: $color-white;
          }
          .el-message-box__headerbtn {
            background-color: $color-error;
            .el-message-box__close {
              color: $color-white;
            }
            &:hover {
              background-color: $color-danger-1;
            }
            &:active {
              background-color: $color-danger-2;
            }
          }
        }
        .el-message-box__content {
          color: $color-white;
        }
        .el-message-box__btns {
          padding-left: 30px;
          text-align: left;
          .el-button {
            &:nth-child(n+2) {
              margin-left: 25px;
            }
          }
        }
      }
    }
  }
}

</style>
